/*
 * Il titolo che gira i nomi e si ferma sulla parola giusta.
 *
 * Liquid ha gia' scritto la frase intera e ferma, con l'ultima parola dentro
 * <span class="radar-making__swap">: qui si anima quello che c'e', non si
 * inventa niente. Script spento, parola sbagliata nell'impostazione, nomi non
 * compilati: in tutti questi casi la pagina resta quella che era.
 *
 * Tre cose imparate misurando, che sembrano dettagli e non lo sono:
 *
 * 1. La parola che cambia va su una riga sua. In fila con le altre, il titolo
 *    cambiava numero di righe a seconda del nome - con MARTIN andava a capo,
 *    con TE no - e a ogni cambio la pagina saltava. Provate 63 larghezze di
 *    finestra: succedeva in 45. Su una riga sua, in nessuna.
 * 2. Ogni giro porta il suo numero. Se ne parte un altro mentre il primo e' a
 *    meta' - la sezione rientra nello schermo, qualcuno ricarica - quello
 *    vecchio trova un numero diverso e smette. Senza, i due scrivevano nello
 *    stesso posto e i nomi si impilavano.
 * 3. L'evidenziazione dell'ultima parola non e' uno sfondo dietro il testo: e'
 *    una seconda copia della parola, gia' evidenziata, scoperta da sinistra.
 *    Uno sfondo in z-index negativo, in certi contesti, finisce dietro la
 *    fascia e lascia scritto blu su blu.
 */
(function (global) {
  'use strict';

  var doc = global.document;
  var QUANTI = 3;

  function fermo() {
    return !global.matchMedia || global.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Tre presi a caso dal mazzo: chi torna sulla home non rivede la stessa
  // fila, e quattordici nomi girano senza far aspettare nessuno.
  function pesca(mazzo) {
    var resto = mazzo.slice();
    var fuori = [];
    while (fuori.length < QUANTI && resto.length) {
      fuori.push(resto.splice(Math.floor(Math.random() * resto.length), 1)[0]);
    }
    return fuori;
  }

  function larghezza(slot, testo) {
    var prova = doc.createElement('span');
    prova.className = 'radar-making__swapword';
    prova.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap';
    prova.textContent = testo;
    slot.appendChild(prova);
    var w = prova.getBoundingClientRect().width;
    slot.removeChild(prova);
    return w;
  }

  function scrivi(slot, testo, finale) {
    var vecchia = slot.querySelector('.radar-making__swapword');
    if (vecchia) {
      vecchia.classList.add('is-out');
      global.setTimeout(function () {
        if (vecchia.parentNode) vecchia.parentNode.removeChild(vecchia);
      }, 320);
    }
    var n = doc.createElement('span');
    n.className = 'radar-making__swapword';
    n.textContent = testo;
    n.setAttribute('data-word', testo);
    slot.style.setProperty('--radar-swap-w', larghezza(slot, testo) + 'px');
    slot.appendChild(n);
    // La classe va sulla parola, non solo sullo slot: il nome uscente resta
    // nel DOM 320ms per la dissolvenza, e con la regola sullo slot si
    // prendeva il riquadro menta anche lui, a meta' strada fuori dal campo.
    if (finale) { slot.classList.add('is-final'); n.classList.add('is-last'); }
  }

  function Titolo(swap) {
    var mazzo = (swap.getAttribute('data-names') || '')
      .split(',')
      .map(function (n) { return n.trim(); })
      .filter(Boolean);
    if (!mazzo.length) return null;

    var h = swap.closest('.radar-court__title');
    var palla = h && h.querySelector('.radar-court__ball');
    if (!h || !palla) return null;

    var parola = swap.textContent.trim();
    if (!parola) return null;

    // Il testo prima della parola si spezza in parole, per farle salire in
    // fila. Si tocca solo il testo che sta davanti allo swap: quello dopo,
    // se c'e', resta com'e'.
    var pezzi = [];
    var nodo = h.firstChild;
    while (nodo && nodo !== swap) {
      pezzi.push(nodo);
      nodo = nodo.nextSibling;
    }
    var prima = pezzi.map(function (n) { return n.textContent; }).join('');
    pezzi.forEach(function (n) { h.removeChild(n); });

    var frag = doc.createDocumentFragment();
    prima.trim().split(/\s+/).filter(Boolean).forEach(function (p, i) {
      var w = doc.createElement('span');
      w.className = 'radar-making__word';
      w.style.setProperty('--radar-word-i', i);
      w.textContent = p;
      frag.appendChild(w);
      frag.appendChild(doc.createTextNode(' '));
    });
    var quante = frag.querySelectorAll('.radar-making__word').length;
    h.insertBefore(frag, swap);

    // La coda: la parola che gira, il suo doppione per chi legge con lo
    // schermo, e la pallina. Un blocco, cosi' la parola sta su una riga sua.
    var coda = doc.createElement('span');
    coda.className = 'radar-making__tail';
    swap.parentNode.insertBefore(coda, swap);
    coda.appendChild(swap);

    // Chi ascolta la pagina sente la frase intera, gia' finita, una volta
    // sola: i nomi che girano sono uno spettacolo per gli occhi.
    var vero = doc.createElement('span');
    vero.className = 'visually-hidden';
    vero.textContent = parola;
    coda.appendChild(vero);

    var pista = doc.createElement('span');
    pista.className = 'radar-making__lane';
    // Fuori campo da subito. Prima l'attesa gliela metteva gira(), che parte
    // solo dopo l'entrata del titolo: misurato, la pallina restava in vista
    // 842ms e poi spariva di colpo per tornare rimbalzando.
    if (!fermo()) pista.classList.add('is-waiting');
    palla.parentNode.removeChild(palla);
    pista.appendChild(palla);
    coda.appendChild(pista);

    swap.classList.add('radar-making__slot');
    swap.style.setProperty('--radar-word-i', quante);
    swap.setAttribute('aria-hidden', 'true');
    swap.textContent = '';

    var giro = 0;

    function gira() {
      var mio = ++giro;
      var vivo = function () { return giro === mio; };

      swap.classList.remove('is-final');
      swap.textContent = '';
      pista.classList.remove('is-bouncing');

      if (fermo()) {
        scrivi(swap, parola, true);
        return;
      }
      pista.classList.add('is-waiting');

      var fila = pesca(mazzo).concat([parola]);
      var i = 0;
      (function passo() {
        if (!vivo()) return;
        var finale = i === fila.length - 1;
        scrivi(swap, fila[i], finale);
        i++;
        if (finale) {
          // Quando la parola ha finito di accendersi, non mentre si accende.
          // La tenda menta dura 460ms: partendo a 140 la pallina entrava in
          // campo col menta ancora al 14%, e le due cose si rubavano l'occhio.
          global.setTimeout(function () {
            if (!vivo()) return;
            pista.classList.remove('is-waiting');
            pista.classList.add('is-bouncing');
          }, 430);
          return;
        }
        // Rallenta strada facendo: i primi scorrono, gli ultimi si leggono.
        global.setTimeout(passo, 620 + i * 90);
      })();
    }

    return function suona() {
      giro++;
      h.classList.add('is-armed');
      void h.offsetWidth;
      h.classList.add('is-playing');
      var atteso = giro;
      global.setTimeout(function () { if (giro === atteso) gira(); }, quante * 65 + 420);
    };
  }

  function avvia() {
    var swaps = doc.querySelectorAll('.radar-making__swap');
    if (!swaps.length) return;

    Array.prototype.forEach.call(swaps, function (swap) {
      var suona = Titolo(swap);
      if (!suona) return;
      // Parte quando la si guarda, non al caricamento: la fascia sta sotto il
      // configuratore, e all'arrivo sulla home non e' ancora nello schermo.
      //
      // Si osserva il titolo, non la fascia che lo contiene. Guardando la
      // fascia - alta 420px da telefono e 560 da computer - una soglia al 40%
      // chiede che se ne veda quasi meta': misurato sulla home, all'arrivo se
      // ne vede il 41% da telefono e lo 0% da computer, cioe' l'animazione
      // non partiva mai o partiva per un pelo. Il titolo e' piccolo e sta in
      // alto: meta' di lui visibile vuol dire che lo stai leggendo davvero.
      if (!global.IntersectionObserver) { suona(); return; }
      var visto = false;
      var occhio = new global.IntersectionObserver(function (voci) {
        voci.forEach(function (v) {
          if (!v.isIntersecting || visto) return;
          visto = true;
          occhio.disconnect();
          suona();
        });
      }, { threshold: 0.5 });
      occhio.observe(swap.closest('.radar-court__title') || swap);
    });
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', avvia);
  else avvia();
})(window);
